(function () {
  /**
   * @param {HTMLElement} section
   * @returns {HTMLElement | null}
   */
  function getContent(section) {
    return section.querySelector('.custom-section-content');
  }

  /**
   * @param {HTMLElement} section
   */
  function finishSection(section) {
    var content = getContent(section);

    if (content && typeof gsap !== 'undefined') {
      gsap.set(content, { clearProps: 'transform,opacity,filter,visibility' });
    }

    section.classList.add('inc-sec-grp--ready');
    section.classList.remove('inc-sec-grp--pending');
  }

  function showFallback() {
    document.querySelectorAll('.inc-sec-grp--animate').forEach(function (node) {
      finishSection(/** @type {HTMLElement} */ (node));
    });
  }

  /**
   * @param {HTMLElement} section
   */
  function killSectionTriggers(section) {
    if (typeof ScrollTrigger === 'undefined') return;

    ScrollTrigger.getAll().forEach(function (trigger) {
      if (trigger.trigger && section.contains(trigger.trigger)) {
        trigger.kill();
      }
    });
  }

  function initIncSectionScroll() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return false;

    gsap.registerPlugin(ScrollTrigger);

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var blurFilter = isMobile ? 'none' : 'blur(8px)';

    document.querySelectorAll('.inc-sec-grp--animate').forEach(function (node) {
      var section = /** @type {HTMLElement} */ (node);

      if (section.dataset.incSecGrpAnimated === 'true') return;
      section.dataset.incSecGrpAnimated = 'true';

      var content = getContent(section);
      var triggerEl = section.querySelector('.section') || section;

      if (!content) {
        finishSection(section);
        return;
      }

      if (reduceMotion) {
        finishSection(section);
        return;
      }

      killSectionTriggers(section);
      section.classList.remove('inc-sec-grp--ready');
      section.classList.add('inc-sec-grp--pending');

      gsap.fromTo(
        content,
        {
          autoAlpha: 0,
          y: isMobile ? 20 : 32,
          filter: blurFilter
        },
        {
          autoAlpha: 1,
          y: 0,
          filter: 'blur(0px)',
          duration: 0.85,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: triggerEl,
            start: 'top 88%',
            once: true
          },
          onComplete: function () {
            finishSection(section);
          }
        }
      );
    });

    ScrollTrigger.refresh();
    return true;
  }

  function boot() {
    if (initIncSectionScroll()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (initIncSectionScroll() || attempts >= 40) {
        window.clearInterval(timer);
        if (attempts >= 40) showFallback();
      }
    }, 50);
  }

  if (!window.__incSecGrpBoot) {
    window.__incSecGrpBoot = boot;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.inc-sec-grp--animate').forEach(function (node) {
        var section = /** @type {HTMLElement} */ (node);
        delete section.dataset.incSecGrpAnimated;
      });
      boot();
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var target = /** @type {HTMLElement | null} */ (event.target);
      if (!target) return;

      var section = target.querySelector('.inc-sec-grp--animate');
      if (!section) return;

      killSectionTriggers(/** @type {HTMLElement} */ (section));
      delete /** @type {HTMLElement} */ (section).dataset.incSecGrpAnimated;
    });
  } else {
    boot();
  }
})();
